<template>
    <footer>
      <div class="container">
        <div class="footer-row d-flex text-center">
            <img loading="lazy" src="@/assets/logos/logo_footer.png" alt="logo esami" class="footer-logo">
            <p class="p-16">Trayectoria, eficiencia y resultados impecables</p>
          <div class="text-lg-start text-center">
            <h4 class="uppercase ">Síguenos en</h4>
            <div class="rrss-cont">
                <a href="https://www.facebook.com/profile.php?id=100075919491900" target="_blank"><img loading="lazy" src="@/assets/icons/rrss-icons/fb.svg" alt="icono facebook"></a>
                <a href="https://www.instagram.com/esami_chile/" target="_blank"><img loading="lazy" src="@/assets/icons/rrss-icons/ig.svg" alt="icono instagram"></a>
                <a href="" class="d-none"><img loading="lazy" src="@/assets/icons/rrss-icons/in.svg" alt="icono linkedin"></a>
            </div>
          </div>
        </div>
       
      </div>
      <div class="copyright d-flex">
        <p class="p-12 pb-0">
            Esami. Todos los derechos reservados. 
        </p>
        <p class="p-12 pb-0">
            Sitio web diseñado por <a href="https://www.zooma.cl/" target="_blank" class="bold p-12">Zooma Design</a> y desarrollado por <a href="https://mariajesuspetour.cl" target="_blank" class="bold p-12">JESU.DEV</a>
        </p>
        </div>
    </footer>
  </template>
  
  <script>
  
  export default {
    name: "FooterComp"
  }
  
  </script>